import React, { useState } from 'react';
import Layout from '../components/Layout';

function CreateSTN({ user, onLogout }) {
  const [devices, setDevices] = useState([]);
  const [scannedCode, setScannedCode] = useState('');
  const [destination, setDestination] = useState('');

  const handleScan = (e) => {
    e.preventDefault();
    if (scannedCode) {
      // TODO: Fetch device details from backend
      setDevices([...devices, { code: scannedCode, sku: 'Unknown' }]);
      setScannedCode('');
    }
  };

  const handleGenerateSTN = () => {
    // TODO: Generate STN with QR code
    alert('STN generation will be implemented');
  };

  return (
    <Layout user={user} onLogout={onLogout}>
      <div className="p-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Create Stock Transfer Note (STN)</h1>
          <p className="text-gray-600 mt-2">Scan devices to create an STN document</p>
        </div>

        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">STN Details</h2>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">Destination</label>
            <select
              value={destination}
              onChange={(e) => setDestination(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select Destination</option>
              <option value="TRC">TRC</option>
              <option value="Warehouse">Warehouse</option>
              <option value="ASC">ASC Partner</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">Scan Device Code</label>
            <form onSubmit={handleScan} className="flex gap-2">
              <input
                type="text"
                value={scannedCode}
                onChange={(e) => setScannedCode(e.target.value)}
                placeholder="Scan or enter device code"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <button
                type="submit"
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                Add
              </button>
            </form>
          </div>
        </div>

        {/* Devices List */}
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">Scanned Devices ({devices.length})</h2>
          {devices.length === 0 ? (
            <p className="text-gray-600">No devices scanned yet</p>
          ) : (
            <div className="space-y-2">
              {devices.map((device, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded">
                  <div>
                    <p className="font-medium">{device.code}</p>
                    <p className="text-sm text-gray-600">{device.sku}</p>
                  </div>
                  <button
                    onClick={() => setDevices(devices.filter((_, i) => i !== index))}
                    className="text-red-600 hover:text-red-800"
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Generate Button */}
        {devices.length > 0 && destination && (
          <button
            onClick={handleGenerateSTN}
            className="w-full px-4 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 font-semibold"
          >
            Generate STN with QR Code
          </button>
        )}
      </div>
    </Layout>
  );
}

export default CreateSTN;
